import {Map} from 'immutable';

export const supported = !!Object.keys(Modernizr).map(c => !!c);
export const features = Map(Modernizr);



// WEBPACK FOOTER //
// ./app/javascript/utils/supported.js